import { createAsyncThunk } from '@reduxjs/toolkit';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';
import { selectTrayUserId } from '../selectors';
import client from '../../../services/api-client';

export default createAsyncThunk('connectionManager/fetchTrayWizardCode', async (_, { getState }) => {
  const state = getState();
  const apiBaseUrl = selectApiBaseUrl(state);
  const trayUserId = selectTrayUserId(state);

  const url = `${apiBaseUrl}/workflows/create-wizard-code/${trayUserId}`;

  const response = await client(url, { method: 'POST' });
  const code = response?.data?.generateAuthorizationCode?.authorizationCode;

  return code;
});
